import React, { useState, useCallback } from 'react';
import {
  AppBar, Toolbar, IconButton, Menu, MenuItem, Box,
  Dialog, DialogContent, List, ListItem, ListItemText,
  Typography, Link, Slide,
} from '@mui/material';
import { Settings as SettingsIcon, Brightness4, Brightness7, Info as InfoIcon, Update } from '@mui/icons-material';
import GitHubIcon from '@mui/icons-material/GitHub';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import { useTheme as useAppTheme } from '../styles/Theme';
import '../styles/styles.css';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Navbar = () => {
  const navigate = useNavigate();
  const { darkMode, toggleDarkMode } = useAppTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const [aboutOpen, setAboutOpen] = useState(false);

  const aboutPrimaryColor = darkMode ? '#f5f5f7' : '#1d1d1f';
  const aboutSecondaryColor = darkMode ? '#aeaeb2' : '#6e6e73';
  const aboutLinkColor = darkMode ? '#2997ff' : '#0071e3';
  const aboutIconBg = darkMode ? 'rgba(41,151,255,0.15)' : 'rgba(0,113,227,0.08)';
  const aboutIconColor = darkMode ? '#2997ff' : '#0071e3';

  const handleMenuOpen = useCallback((event) => { setAnchorEl(event.currentTarget); }, []);
  const handleMenuClose = useCallback(() => { setAnchorEl(null); }, []);

  const handleProfile = useCallback(() => {
    navigate('/profile');
    handleMenuClose();
  }, [navigate, handleMenuClose]);

  const handleLogout = useCallback(() => {
    localStorage.removeItem('token');
    localStorage.removeItem('user_id');
    localStorage.removeItem('username');
    localStorage.removeItem('name');
    localStorage.removeItem('darkMode');
    sessionStorage.clear();
    handleMenuClose();
    window.location.reload();
  }, [handleMenuClose]);


  return (
    <>
      <AppBar position="fixed" className="navAppBar">
        <Toolbar className="navToolbar">
          <Box className="navBrand" onClick={() => navigate('/')}>
            <Typography sx={{
              fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Helvetica Neue', sans-serif",
              fontSize: '1.3rem',
              fontWeight: 600,
              letterSpacing: '-0.5px',
              color: darkMode ? '#f5f5f7' : '#1d1d1f',
              cursor: 'pointer',
              userSelect: 'none',
            }}>
              Dashboard
            </Typography>
          </Box>
          <div className="navFlexGrow" />
          <IconButton className="navIconButton" onClick={toggleDarkMode} aria-label="Toggle dark mode">
            {darkMode ? <Brightness4 /> : <Brightness7 />}
          </IconButton>
          <IconButton className="navIconButton" onClick={handleMenuOpen} aria-label="Settings">
            <SettingsIcon />
          </IconButton>
          <IconButton className="navIconButton" onClick={() => setAboutOpen(true)} aria-label="About">
            <InfoIcon />
          </IconButton>
          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
            <MenuItem onClick={handleProfile}>Profile</MenuItem>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      <Dialog open={aboutOpen} onClose={() => setAboutOpen(false)} TransitionComponent={Transition} maxWidth="xs" fullWidth PaperProps={{ className: 'aboutModalPaper' }}>
        <DialogContent className="aboutModalContent">
          <IconButton onClick={() => setAboutOpen(false)} className="aboutModalClose" size="small">
            <CloseIcon fontSize="small" />
          </IconButton>
          <Box className="aboutModalTitleBox">
            <Typography className="aboutModalLabel">ABOUT</Typography>
            <Typography sx={{
              fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Helvetica Neue', sans-serif",
              fontSize: '1.8rem',
              fontWeight: 700,
              letterSpacing: '-0.5px',
              color: aboutPrimaryColor,
              mb: 0.5,
            }}>
              SafePass
            </Typography>
            <Typography className="aboutModalSubtitle">
              SafePass is the simple and secure way to keep your passwords organized and always within reach with no need to remember them.
            </Typography>
          </Box>
          <List className="aboutList" style={{ marginTop: 8 }}>
            <ListItem className="aboutListItem">
              <Box className="aboutModalIconBox" style={{ backgroundColor: aboutIconBg }}>
                <Update sx={{ fontSize: 18, color: aboutIconColor }} />
              </Box>
              <ListItemText
                sx={{ ml: 2 }}
                primary={<span style={{ fontSize: '0.9rem', fontWeight: 600, color: aboutPrimaryColor }}>Version</span>}
                secondary={<span style={{ fontSize: '0.85rem', color: aboutSecondaryColor }}>3.0.0</span>}
              />
            </ListItem>
            <ListItem className="aboutListItem">
              <Box className="aboutModalIconBox" style={{ backgroundColor: aboutIconBg }}>
                <GitHubIcon sx={{ fontSize: 18, color: aboutIconColor }} />
              </Box>
              <ListItemText
                sx={{ ml: 2 }}
                primary={
                  <span style={{ fontSize: '0.9rem', fontWeight: 600, color: aboutPrimaryColor }}>
                    Developed by{' '}
                    <Link href="https://andresnicolas.com/" target="_blank" rel="noopener" style={{ color: aboutLinkColor, textDecoration: 'none', fontWeight: 600, WebkitTextFillColor: aboutLinkColor }}>
                      Andres Nicolas
                    </Link>
                  </span>
                }
              />
            </ListItem>
          </List>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Navbar;